import { generateRouteStats } from '@/lib/models/route/utils/generate-route-stats';
import { transformCarrierDictionary } from '@/lib/transformers/carrier';
import { transformLineDictionary } from '@/lib/transformers/line';
import { transformLocationDictionary } from '@/lib/transformers/location';
import { transformRoute } from '@/lib/transformers/route';
import { transformVehicleDictionary } from '@/lib/transformers/vehicle';
import { RouteResultInterfaceV2 } from '@/types';
import { RouteResultApiV4Interface } from '@/types/api-types';

export const transformRouteResults = (result: RouteResultApiV4Interface): RouteResultInterfaceV2 => {
  const {
    carriers: apiCarriers,
    locations: apiLocations,
    routes: apiRoutes,
    pathCoords: polylines,
    vehicles: apiVehicles,
    lines: apiLines,
  } = result;

  const routes = apiRoutes.map((route) => transformRoute({ route }));
  const vehicles = transformVehicleDictionary(apiVehicles);
  const carriers = transformCarrierDictionary(apiCarriers);
  const locations = transformLocationDictionary(apiLocations);
  const stats = generateRouteStats(routes);
  const lines = transformLineDictionary(apiLines);

  return {
    carriers,
    locations,
    routes,
    vehicles,
    lines,
    polylines,
    stats,
  };
};
